$shm_hitalama_map_widget_float_table_relation_atom $mol_view
	value? \
	dictionary *
	active \
	open? null
	sub /
		^ item_visible /
			<= Item $mol_button_minor
				title <= item_label \
				sub <= item_content /
				click? <=> item_open? null
				attr *
					^
					selected <= item_current false
		<= Picker $mol_select
			value? <=> value?
			dictionary <= dictionary
			option_content* <= option_content* /
			trigger_content / <= Picker_icon $mol_icon_dots_vertical
		<= Create $mol_button_minor
			title \Создать связанную запись
			click? <=> create? null
			sub / <= Create_icon $mol_icon_plus
			attr *
				^
				selected <= create_current false

$shm_hitalama_map_widget_float_table_relation_list_checks $shm_check_list
	relation null
	Check* $mol_check_box
		title <= check_title* \
		sub <= check_content* /

$shm_hitalama_map_widget_float_table_relation_list $mol_view
	value? /string
	dictionary *
	active \
	open? null
	sub /
		<= Picker $mol_pick
			trigger_content / <= Picker_icon $mol_icon_dots_vertical
			bubble_content / <= Checks $shm_hitalama_map_widget_float_table_relation_list_checks
				relation <= relation_self
				options <= option_ids /string
				value? <=> value?
		^ items /$mol_view
		<= Create $mol_button_minor
			title \Создать связанную запись
			click? <=> create? null
			sub / <= Create_icon $mol_icon_plus
			attr *
				^
				selected <= create_current false
	Item* $mol_button_minor
		title <= item_label* \
		sub <= item_content* /
		click? <=> item_open*? null
		attr *
			^
			selected <= item_current* false
	relation_self null
